export default __webpack_public_path__ + "static/media/box-content-decor.15191954.svg";